export const AD_COUNTDOWN = 'adCountdown';
export const CAPTIONS_BUTTON = 'captionsButton';
export const CLOSE_BUTTON = 'CloseButton';
export const CURRENT_TIME_DISPLAY = 'currentTimeDisplay';
export const FULLSCREEN_TOGGLE = 'fullscreenToggle';
export const MUTE_TOGGLE = 'muteToggle';
export const MUTED_OVERLAY_BUTTON = 'mutedOverlayButton';
export const PLAY_TOGGLE = 'playToggle';
export const PROGRESS_CONTROL = 'progressControl';
export const SHARE_CONTROL = 'shareControl';
export const SHARE_OVERLAY = 'shareOverlay';
export const AD_CLICK_OVERLAY = 'adClickOverlay';
export const SUBTITLES_BUTTON = 'subtitlesButton';
export const VOLUME_CONTROL = 'volumeControl';
export const VOLUME_PANEL = 'volumePanel';
export const WATCH_BUTTON = 'watchButton';
export const THEATER_TOGGLE = 'theaterToggle';
export const CONTROL_BAR = 'controlBar';



// WEBPACK FOOTER //
// ./src/ui/UIControlsNames.js